import Vue from "vue";

export default Vue.extend({
  template: `
    <div>
      <a v-if="pack" v-bind:href="pack" :class="tailwindClass">
        Packing
        <icon set="outline" name="document-download" class="ml-1 inline-block h-5 w-5 align-middle text-white" />
      </a>
      <a v-if="pick" v-bind:href="pick" :class="tailwindClass">
        Pick
        <icon set="outline" name="document-download" class="ml-1 inline-block h-5 w-5 align-middle text-white" />
      </a>
    </div>`,
  data: function() {
    return {
      pack: false,
      pick: false,
      tailwindClass:
        "inline-flex items-center px-1.5 py-0.5 border border-transparent text-sm leading-4 rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
    };
  },
  beforeCreate() {},
  beforeMount() {
    this.hasDownload(this.params.value);
  },
  mounted() {},
  methods: {
    hasDownload(arr) {
      if (arr.packing) this.pack = arr.packing;
      if (arr.pick) this.pick = arr.pick;
    }
  }
});
